import * as React from 'react';
import { isSmallDashboardCard } from 'utils/pwa-dashboard-layout';
import type { CardId } from './cards/types';

type PwaDashboardGridProps = {
  cardIds: CardId[];
  renderCard: (cardId: CardId) => React.ReactNode;
};

/** Auto-height 2-column dashboard for PWA — small cards side-by-side, large cards full width. */
export const PwaDashboardGrid: React.FC<PwaDashboardGridProps> = ({
  cardIds,
  renderCard,
}) => {
  return (
    <div className="scope-pwa-dashboard-grid">
      {cardIds.map((cardId) => {
        const isLarge = !isSmallDashboardCard(cardId);
        return (
          <div
            key={cardId}
            className={`scope-pwa-dashboard-grid__item${
              isLarge ? ' scope-pwa-dashboard-grid__item--large' : ''
            }`}
          >
            {renderCard(cardId)}
          </div>
        );
      })}
    </div>
  );
};

export default PwaDashboardGrid;
